module.exports = __webpack_public_path__ + "img/icon106.fa20ae4e.jpeg";